import { useCallback, useRef } from 'react';
import { getCurrentTime } from '../utils/date-utils';

/**
 * onPress 연타(더블탭) 방지용 throttle 훅. (네이티브 동일, 기본 700ms)
 * 마지막 호출로부터 delayMs 가 지나기 전의 재호출은 무시한다.
 * 네비게이션/딥링크처럼 한 번만 실행되어야 하는 클릭 핸들러를 감싸는 용도.
 *
 * 인자를 받는 핸들러도 감쌀 수 있다(인자는 그대로 forward). 기존 `() => void` 사용처는
 * A = [] 로 추론되어 그대로 동작한다.
 */
export const useThrottle = <A extends unknown[]>(
  callback: (...args: A) => void,
  delayMs = 700,
) => {
  const lastCallRef = useRef(0);
  return useCallback(
    (...args: A) => {
      const now = getCurrentTime();
      if (now - lastCallRef.current >= delayMs) {
        lastCallRef.current = now;
        callback(...args);
      }
    },
    [callback, delayMs],
  );
};
